import { getAuth } from "firebase/auth";
import Notification from "../models/Notification.js";

const GET_NOTIFICATIONS_URL =
  "https://europe-west3-hyper-e122e.cloudfunctions.net/get_notifications";

const DELETE_NOTIFICATION_URL =
  "https://europe-west3-hyper-e122e.cloudfunctions.net/delete_notification";

class NotificationService {

  static async getUserNotifications() {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        throw new Error("❌ Пользователь не авторизован");
      }

      const token = await currentUser.getIdToken(true);

      const response = await fetch(GET_NOTIFICATIONS_URL, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `⚠️ Ошибка запроса: ${response.status} — ${errorText}`
        );
      }

      const data = await response.json();

      if (!Array.isArray(data.notifications)) {
        throw new Error("❌ Ожидался массив notifications");
      }

      return data.notifications.map(
        item => new Notification(item)
      );

    } catch (error) {
      console.error(
        "❌ Ошибка загрузки уведомлений:",
        error.message
      );
      return [];
    }
  }

  static async deleteNotification(notificationId) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        throw new Error("❌ Пользователь не авторизован");
      }

      const token = await currentUser.getIdToken(true);

      const response = await fetch(
        DELETE_NOTIFICATION_URL,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            notification_id: notificationId,
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();

        throw new Error(
          `⚠️ Ошибка удаления: ${response.status} — ${errorText}`
        );
      }

      const data = await response.json();

      console.log(
        "✅ Notification deleted:",
        notificationId
      );

      return data;

    } catch (error) {
      console.error(
        "❌ Ошибка удаления уведомления:",
        error.message
      );

      return null;
    }
  }
}

export default NotificationService;